import React from "react";
import styled from "styled-components";

export default function ScoreRuleRoundInput(props) {
  const { index, value, setValue, placeholder, isEdit } = props;

	function handleChange(e) {
    const input = e.target.value;
    const onlyNumbers = input.replace(/[^0-9]/g, ''); // 숫자 외 문자 제거
    const limited = onlyNumbers.slice(0, 3); // 최대 3자리까지만 허용
    
    setValue(limited, index);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
	}

  return (
    <InputView>
      <Input
        placeholder={placeholder}
        value={value}
        type='text'
        disabled={!isEdit}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
      <Text fontFamily='Poppins-Medium' fontSize={14} color='#FFFFFF' cursor='default'>R</Text>
    </InputView>
  )
}

const InputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 7px 15px;

  width: calc(100% - 32px);

  border: 1px solid #CBCBCB;
  border-radius: 30px;
  background-color: #2F2F32;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 17px;

	width: 80%;
	height: 17px;

	padding: 0 0 0 0;
	margin: 0 0 0 0;

	outline: none;
	
	color: #FFFFFF;

  border: none;
  background-color: #2F2F32;

	::placeholder {
		color: #6A6A6C;
	}
  
  transition: all 0.3s ease-in-out;
`;

const Text = styled.div`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
